import { render, staticRenderFns } from "./AssetOwner.vue?vue&type=template&id=392ecd1c&"
import script from "./AssetOwner.vue?vue&type=script&lang=js&"
export * from "./AssetOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports